import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/views/HomePage';
import ProductsPage from '@/views/ProductsPage';
import ProductPage from '@/views/ProductPage';
import ProductSpecPage from '@/views/ProductSpecPage';
import ProducersPage from '@/views/ProducersPage';
import ProducerPage from '@/views/ProducerPage';
import AboutPage from '@/views/AboutPage';
import ContactPage from '@/views/ContactPage';
import FavouritesPage from '@/views/FavouritesPage';
import GeneralPage from '@/views/GeneralPage';
import NotFoundPage from '@/views/NotFoundPage';

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {path: '/', name: 'root', component: HomePage},
    {path: '/products', name: 'products', component: ProductsPage},
    {path: '/products/:slug', name: 'product', component: ProductPage},
    {path: '/products/:slug/spec', name: 'product-spec', component: ProductSpecPage},
    {path: '/producers', name: 'producers', component: ProducersPage},
    {path: '/producers/:slug', name: 'producer', component: ProducerPage},
    {path: '/about', name: 'about', component: AboutPage},
    {path: '/contact', name: 'contact', component: ContactPage},
    {path: '/favourites', name: 'favourites', component: FavouritesPage},
    {path: '/terms-and-conditions', name: 'terms', component: GeneralPage},
    {path: '/privacy-policy', name: 'privacy', component: GeneralPage},
    {path: '/*', name: '404', component: NotFoundPage},
  ],
  linkActiveClass: "active",
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})
